import * as React from "react";
import {useState} from "react";

// import { createStyles, Theme } from '@mui/material/styles';
// import { makeStyles } from '@mui/styles';
import {Button, CardHeader, SxProps, TableCell, TableRow, Theme, Typography} from '@mui/material';

import {ExpandLess, ExpandMore} from "@mui/icons-material/";
import AddIcon from '@mui/icons-material/Add';
import SyncIcon from '@mui/icons-material/Sync';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import {TableLoading, TableLoadingSkeleton, TableWithError, TableWithoutData} from './TableLayoutsState';

import {dateFormatter} from 'src/utils/formatters/dateFormatter';
import {TotalsRowMap} from "./TableList";
import {numberFormatter} from "src/utils/formatters/numberFormatter";
import {stringFormatter} from "src/utils/formatters/stringFormatter";
import {useTranslation} from "react-i18next";

// const useStyles: any = makeStyles((theme: Theme) =>
//     createStyles({
//         root: {
//             backgroundColor: 'transparent',
//             padding: '0 2.25rem',
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'stretch',
//             flexWrap: 'wrap',
//             minHeight: '70px'
//         },
//         contenedorBotones: {
//             marginTop: 4,
//             marginBottom: -5
//         },
//         botones: {
//             marginRight: theme.spacing(1)
//         },
//         tableCellButton: {
//             zoom: "80%",
//         },

//         iconBoolDanger: {
//             fill: "#f44336 !important",
//             fontSize: "19px !important",
//         },
//         iconBoolSuccess: {
//             fill: "#4caf50 !important",
//             fontSize: "19px !important",
//         },
//     }),
// );

// funcion helper para generar los bordes para las columnas con el prop de dividers
function createDividerStyles(dividers?: ITableColumn['dividers']): SxProps<Theme> {
    const color = 'rgba(224, 224, 224, 1)';
    const format = (value: string | number) => `${typeof value === 'number' ? value + 'px' : value} solid ${color}`;

    return {
        ...(dividers?.top && { borderTop: format(dividers.top) }),
        ...(dividers?.right && { borderRight: format(dividers.right) }),
        ...(dividers?.bottom && { borderBottom: format(dividers.bottom) }),
        ...(dividers?.left && { borderLeft: format(dividers.left) }),
    };
}

export interface ITableColumn {
    hasHTML?: boolean,
    noWrap?: boolean,
    label: string,
    value?: string,
    width?: string | number | undefined,
    size?: "small" | "medium" | undefined
    currency?: string,
    type?: TableColumnType,
    minDecimals?: number,
    maxDecimals?: number,
    textAlign?: 'left' | 'center' | 'right',
    onRenderCell?: (entity: any, ...args: any[]) => React.ReactElement,
    dividers?: {
        top?: string | number,
        right?: string | number,
        bottom?: string | number,
        left?: string | number
    }
}

export interface ITableGroups {
    firstColumn: number,
    lastColumn: number,
    label: React.ReactNode,
    dividers?: {
        top?: string | number,
        right?: string | number,
        bottom?: string | number,
        left?: string | number
    }
}

export enum TableColumnType {
    Date = 1,
    Button = 2,
    Boolean = 3,
    Chart = 4,
    Currency = 5,
    Number = 6,
    Decimal = 7,
    CNPJ = 8,
    Percentage = 9,
    Default = 10,
    Warning = 11
}

interface ITableRowEntityProps {
    keyComponent: React.Key,
    entity: any,
    columns: ITableColumn[],
    firstRow?: boolean,
}

export function TableRowEntity(props: ITableRowEntityProps) {

    // const classes = useStyles();

    function getColumnKey(columnIndex: number, value: string | undefined) {
        return `${props.keyComponent}_${columnIndex}_${value}`;
    }


    return (
        <TableRow>
            {
                props.columns.map((oneColumn, index) => {

                    const columnValue: string = (oneColumn.value || "");
                    const textAlign: string = oneColumn.textAlign || "left";
                    const cellSx = createDividerStyles(oneColumn?.['dividers'])

                    switch (oneColumn.type) {
                        case TableColumnType.Boolean:
                            return (
                                <TableCell key={getColumnKey(index, columnValue)} sx={cellSx}>
                                    {
                                        (props.entity[columnValue] as boolean) ?

                                            // <CheckCircleOutlineIcon /*className={classes.iconBoolSuccess}*/ /> :
                                            // <RemoveCircleIcon /*className={classes.iconBoolDanger}*/ />

                                            <CheckCircleOutlineIcon sx={{
                                                fill: "#4caf50 !important",
                                                fontSize: "19px !important",
                                            }}/> : <RemoveCircleIcon sx={{
                                                fill: "#f44336 !important",
                                                fontSize: "19px !important",
                                            }}/>
                                    }
                                </TableCell>
                            )

                        case TableColumnType.Warning:
                            return (
                                <TableCell key={getColumnKey(index, columnValue)} sx={cellSx}>
                                    {
                                        (props.entity[columnValue] as boolean) ?

                                            <WarningAmberIcon sx={{
                                                fill: (theme) => theme.palette.warning.main,
                                                fontSize: "19px !important",
                                            }}/> : <></>
                                    }
                                </TableCell>
                            )

                        case TableColumnType.Date:
                            return (
                                <TableCell key={getColumnKey(index, columnValue)}
                                           sx={{textAlign: `${textAlign} !important`, ...cellSx}}>
                                    {dateFormatter.toShortDate(props.entity[columnValue])}
                                </TableCell>
                            )

                        case TableColumnType.Button:
                            return (
                                <TableCell
                                    key={getColumnKey(index, columnValue)} /*className={classes.tableCellButton}*/
                                    sx={{
                                        zoom: "80%",
                                        ...cellSx
                                    }}
                                    width={oneColumn.width}>
                                    {oneColumn.onRenderCell && oneColumn.onRenderCell(props.entity)}
                                </TableCell>
                            )
                        case TableColumnType.Chart:
                            return (
                                props?.firstRow
                                    ?
                                    <TableCell
                                        align={'center'}
                                        style={{borderBottom: 'none'}} rowSpan={7}
                                        sx={cellSx}
                                    >
                                        {
                                            oneColumn.onRenderCell && oneColumn.onRenderCell(props.entity)}
                                    </TableCell>
                                    : <></>

                            )

                        case TableColumnType.Currency:
                            return (
                                <TableCell key={getColumnKey(index, columnValue)} sx={cellSx}>
                                    {numberFormatter.toStringWithAmount(props.entity[columnValue], oneColumn.currency || "$",
                                        oneColumn.minDecimals, oneColumn.maxDecimals)}
                                </TableCell>
                            )

                        case TableColumnType.Number:
                            return (
                                <TableCell key={getColumnKey(index, columnValue)} sx={cellSx}>
                                    {numberFormatter.toNumberWithoutDecimal(props.entity[columnValue])}
                                </TableCell>
                            )

                        case TableColumnType.Decimal:
                            return (
                                <TableCell key={getColumnKey(index, columnValue)} sx={cellSx}>
                                    {numberFormatter.toStringWithAmount(props.entity[columnValue] || 0, '',
                                        oneColumn.minDecimals || 0, oneColumn.maxDecimals)}
                                </TableCell>
                            )

                        case TableColumnType.CNPJ:
                            return (
                                <TableCell key={getColumnKey(index, columnValue)} sx={cellSx}>
                                    {stringFormatter.toCNPJ(props.entity[columnValue])}
                                </TableCell>
                            )

                        case TableColumnType.Percentage:
                            return (
                                <TableCell key={getColumnKey(index, columnValue)} sx={cellSx}>
                                    {numberFormatter.toStringWithPercentage(props.entity[columnValue], oneColumn.minDecimals || 0, oneColumn.maxDecimals)}
                                </TableCell>
                            )

                        default:
                            return (
                                <TableCell key={getColumnKey(index, columnValue)}
                                           width={oneColumn.width}
                                           sx={{textAlign: `${textAlign} !important`, ...cellSx}}
                                >
                                    {oneColumn.onRenderCell ? oneColumn.onRenderCell(props.entity) :
                                        props.entity[columnValue]}
                                </TableCell>
                            )
                    }
                })
            }
        </TableRow>
    )
}

interface TableTotalsRowEntityProps<T> {
    totalsRowMapList: TotalsRowMap<T>[],
    entityList: T[] | null | undefined,
    columns: ITableColumn[],
}

function TableTotalsRowEntity<T>(props: TableTotalsRowEntityProps<T>) {
    return (
        <TableRow>
            <TableCell variant={'footer'} style={{borderBottom: 'none'}}><Typography
                sx={{fontWeight: 800}}>TOTAL</Typography></TableCell>
            {
                props.columns.slice(1).map((c, idx) => {
                    const map = props.totalsRowMapList?.find(map => map.columnIndex === idx + 1)
                    const chartColumn = props.columns[idx + 1].type === TableColumnType.Chart
                    let cell = <TableCell
                        variant={'footer'}
                        style={chartColumn ? {border: 'none'} : {borderBottom: 'none'}}
                    />
                    if (chartColumn) {
                        cell = <></>
                    }
                    if (map) {
                        cell =
                            <TableCell variant={'footer'} style={{borderBottom: 'none'}}>
                                {
                                    props.columns[idx + 1]?.onRenderCell
                                        ? React.cloneElement(props.columns[idx + 1].onRenderCell!({
                                            [map.entityField]: props.entityList?.reduce((sum, curr: any) => sum + curr?.[map.entityField], 0)
                                        }), {sx: {color: 'primary.main', fontWeight: 800}})
                                        : props.entityList?.reduce((sum, curr: any) => sum + curr?.[map.entityField], 0)
                                }
                            </TableCell>
                    }

                    return cell
                })
            }
        </TableRow>
    )
}


interface ITableRowHeaderProps {
    columns: ITableColumn[];
    groups?: ITableGroups[];
}

export function TableRowHeader(props: ITableRowHeaderProps) {
    const {t} = useTranslation();

    return (
        <>
            {props.groups && props.groups.length > 0 && (
                <TableRow>
                    {
                        props.groups.map((oneGroup, index) => {
                            const cellSx = createDividerStyles(oneGroup?.['dividers'])

                            return (
                                <TableCell
                                    key={`group-header-${index}`}
                                    variant={'head'}
                                    colSpan={oneGroup.lastColumn - oneGroup.firstColumn + 1}
                                    align="center"
                                    sx={cellSx}
                                >
                                    <Typography variant={'body2'}>
                                        {oneGroup.label}
                                    </Typography>
                                </TableCell>
                            )
                        })
                    }
                </TableRow>
            )}
            <TableRow>
                {props.columns.map((oneColumn, index) => {
                    const hasHTML = oneColumn.hasHTML || false;
                    const whiteSpace = oneColumn.noWrap ? 'nowrap' : 'break-spaces';

                    const headerSx = {
                        whiteSpace,
                        ...createDividerStyles(oneColumn.dividers)
                    } as SxProps<Theme>;

                    return (
                        <TableCell
                            width={oneColumn.width}
                            size={oneColumn.size}
                            sx={headerSx}
                            key={`${oneColumn.value}_${index}`}
                            variant={'head'}

                        >
                            <Typography variant={'body2'} align={oneColumn.textAlign}>

                                {hasHTML ?
                                    <span dangerouslySetInnerHTML={{__html: oneColumn.label}}/> : t(oneColumn.label)}
                            </Typography>
                        </TableCell>
                    );
                })}
            </TableRow>
        </>
    );
}

interface ITableGroupHeaderRowProps {
    columns: ITableGroups[],
}

export function TableRowGroupHeader(props: ITableGroupHeaderRowProps) {
    const {t} = useTranslation();
    const sortedColumns = [...props.columns].sort((a, b) => a.firstColumn - b.firstColumn)
    const firstGroupColumnIndex = sortedColumns[0].firstColumn

    return (
        <TableRow>
            {

                //Empty cells before first group
                [...Array(firstGroupColumnIndex)].map((_, index) => <TableCell key={index}/>)
            }
            {sortedColumns.map((oneColumn, index) => {
                const cellSx = createDividerStyles(oneColumn.dividers)

                return (
                    <TableCell key={`$group-header-${index}`} variant={'head'}
                               colSpan={1 + oneColumn.lastColumn - oneColumn.firstColumn}
                               sx={cellSx}
                    >
                        <Typography variant={'body2'} align={'center'}>
                            {oneColumn.label}
                        </Typography>
                    </TableCell>
                )
            })}
        </TableRow>
    )
}

interface ITableCardHeaderProps {
    title: string,
    subtitle?: string | null,
    onReload?: () => void,
    onToggleShowChildren?: () => void,
    onNewRegister?: () => void,
    childrenName?: string,
    actions?: React.ReactNode
}

export function TableCardHeader(props: ITableCardHeaderProps) {

    // const classes = useStyles();

    const [filterExpanded, setFilterExpanded] = useState<boolean>(true)

    const onToggleClicked = () => {
        if (props.onToggleShowChildren) {
            props.onToggleShowChildren()
        }

        return setFilterExpanded(!filterExpanded);
    }

    return (
        <CardHeader

            /*className={classes.root}*/
            // sx={{
            //     backgroundColor: 'transparent',
            //     padding: '0 2.25rem',
            //     display: 'flex',
            //     justifyContent: 'space-between',
            //     alignItems: 'stretch',
            //     flexWrap: 'wrap',
            //     minHeight: '70px'
            // }}
            title={props.title}
            subheader={props.subtitle}
            action={
                <Typography component="div" /*className={classes.contenedorBotones}*/
                            sx={{
                                marginTop: 4,
                                marginBottom: -5
                            }}
                >
                    {
                        props.onToggleShowChildren &&
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={filterExpanded ? <ExpandLess/> : <ExpandMore/>}

                            // className={classes.botones}
                            sx={{
                                marginRight: (theme: Theme) => theme.spacing(1)
                            }}
                            onClick={onToggleClicked}
                        >{props.childrenName}</Button>
                    }
                    {
                        props.onNewRegister &&
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<AddIcon/>}

                            // className={classes.botones}
                            sx={{
                                marginRight: (theme: Theme) => theme.spacing(1)
                            }}
                            onClick={props.onNewRegister}>Nuevo</Button>
                    }
                    {
                        props.onReload &&
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<SyncIcon/>}

                            // className={classes.botones}
                            sx={{
                                marginRight: (theme: Theme) => theme.spacing(1)
                            }}
                            onClick={props.onReload}>Recargar</Button>
                    }

                    {props.actions && props.actions}
                </Typography>
            }
        />
    )
}


interface ITableBodyEntityListProps<T> {
    entityList: T[] | null | undefined,
    columns: ITableColumn[],
    isLoading: boolean,
    error: boolean,
    totalsRowMapList?: TotalsRowMap<T>[],
    loadingWithSkeleton?: boolean
    noDataMessage?: string | null,
}

export function TableBodyEntityList<T>(props: ITableBodyEntityListProps<T>) {

    return <>{
        props.error ?
            <TableWithError colSpan={props.columns.length}/>
            :
            props.isLoading ?
                props.loadingWithSkeleton ?
                    <TableLoadingSkeleton colSpan={props.columns.length}/>
                    :
                    <TableLoading colSpan={props.columns.length}/>
                :
                props.entityList ?
                    props.entityList.length > 0 ?
                        <>
                            {props.entityList.map((oneEntity, index) => {
                                const keyTableRowEntity = `${(oneEntity as any)["id"]}_${index}`;

                                return (
                                    <TableRowEntity key={keyTableRowEntity}
                                                    keyComponent={keyTableRowEntity}
                                                    entity={(oneEntity as any)}
                                                    columns={props.columns}
                                                    firstRow={index === 0}
                                    />)
                            })}
                            {
                                props?.totalsRowMapList
                                && <TableTotalsRowEntity
                                    columns={props.columns}
                                    entityList={props.entityList}
                                    totalsRowMapList={props.totalsRowMapList}
                                />
                            }
                            {/* si hay un chart se agregan filas vacias a la tabla
                                para mostrar el chart sin que se rompa
                            */}
                            {
                                props.columns.map(e => e.type).includes(TableColumnType.Chart) &&
                                [...Array(Math.max(5 - props.entityList.length, 0))].map((index) =>
                                    <TableRow
                                        key={index}
                                    >
                                        <TableCell
                                            colSpan={props.columns.length}
                                            style={{border: 'none'}}> </TableCell>
                                    </TableRow>
                                )}

                        </>
                        :
                        <TableWithoutData colSpan={props.columns.length} noDataMessage={props.noDataMessage}/>
                    :
                    <TableWithError colSpan={props.columns.length}/>
    }</>
}
